export default __webpack_public_path__ + "static/media/coporate.9656045b.png";